import { render, staticRenderFns } from "./populacePane.vue?vue&type=template&id=926a043c"
import script from "./populacePane.vue?vue&type=script&lang=js"
export * from "./populacePane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports